import { render, staticRenderFns } from "./CreateStagingModal.vue?vue&type=template&id=c7f4a51c&scoped=true"
import script from "./CreateStagingModal.vue?vue&type=script&lang=js"
export * from "./CreateStagingModal.vue?vue&type=script&lang=js"
import style0 from "./BasicModal.scss?vue&type=style&index=0&id=c7f4a51c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f4a51c",
  null
  
)

export default component.exports